module.exports = __webpack_public_path__ + "img/main_technic_5.211b0579.jpg";